import type { AddressReadOnlySectionMode } from '../types/utils'
/** About-yourself read-only address — always show labels (Angular #addressView). */

export function showApplicationAddressReadOnlyField(
  _mode: AddressReadOnlySectionMode,
  _displayText: string,
): boolean {
  return true
}

export function showApplicationAddressReadOnlyScalar(
  _mode: AddressReadOnlySectionMode,
  _value: unknown,
): boolean {
  return true
}
